<template>
    <form @submit.prevent="formSubmit">
        <!-- <div class="form-group basic">
            <div class="input-wrapper">
                <label class="label" for="account1">Red donde quieres enviar</label>
                <select class="form-control custom-select" id="account1" v-model="form.network" required>
                    <option v-for="(network, n_i) in networks" v-bind:key="'ni'+n_i" :value="n_i">{{network.name}}</option>
                </select>
            </div>
        </div>
        <div class="form-group basic">
            <div class="input-wrapper">
                <label class="label" for="account1">Activo</label>
                <select class="form-control custom-select" id="account1" v-model="form.asset" required>
                    <option v-for="(asset2, a_i) in assets" v-bind:key="'ai'+a_i" :value="a_i">{{asset2.currency.name}} ({{asset2.currency.symbol}})</option>
                </select>
            </div>
        </div>
        <div class="form-group basic">
            <label class="label">Billetera de destino (Address)</label>
            <div class="input-group mb-2">
                <span class="input-group-text" id="basic-addona1">{{ asset.network.name }}</span>
                <input type="text" class="form-control" v-model="form.to" placeholder="ingrese la billetera de destino" />
            </div>
        </div>
        <div class="form-group basic">
          <label class="label" v-if="asset != null">Ingrese Cantidad - Balance: {{ asset.balance }}</label>
            <div class="input-group mb-2">
              <span class="input-group-text" id="basic-addonb1">{{asset.currency.symbol}}</span>
                <input type="text" class="form-control" placeholder="Ingrese una cantidad" v-model="form.amountFloat" required />
            </div>
        </div> -->
        


        <div class="form-group basic">
          <div class="input-wrapper">
            <label class="label" for="form-withdraw-asset">Activo</label>
            <select class="form-control custom-select" id="form-withdraw-asset" v-model="assetSelected" required>
              <!-- <option v-for="(asset, a_i) in portfolio" v-bind:key="'form-withdraw-asset-'+a_i" :value="a_i">{{asset.name}} ({{asset.symbol}})</option> -->
              <template v-for="(asset, a_i) in portfolio" v-bind:key="'form-blocking-asset-'+a_i">
                <option :value="a_i" v-if="this.portfolio[a_i].networks_withdraw.length > 0">
                  {{asset.name}} ({{asset.symbol}})
                </option>
              </template>
            </select>
          </div>
        </div>
        <div class="form-group basic">
            <div class="input-wrapper">
                <label class="label" for="account1">Red donde quieres enviar</label>
                <select class="form-control custom-select" id="form-withdraw-network" v-model="networkSelected" required>
                    <option v-for="(network, n_i) in networks" v-bind:key="'form-withdraw-network-'+n_i" :value="n_i">
                      <!-- {{network.name}} -->
                        {{network.dst.network.name}} ({{ $root.recortarCadena(network.dst.contract_address) }})
                    </option>
                </select>
            </div>
        </div>
        <div class="form-group basic">
            <label class="label">Billetera de destino (Address)</label>
            <div class="input-group mb-2">
                <!-- <span class="input-group-text" id="basic-addona1">{{ asset.network.name }}</span> -->
                <input type="text" class="form-control" v-model="form.to" placeholder="ingrese la billetera de destino" />
            </div>
        </div>
        <div class="form-group basic">
          <label class="label" v-if="asset != null">Ingrese Cantidad - Balance: {{network.src.balance}} {{ asset.symbol }}</label>
            <div class="input-group mb-2">
              <span class="input-group-text" id="basic-addonb1">{{asset.symbol}}</span>
                <input type="text" class="form-control" placeholder="Ingrese una cantidad" v-model="form.amountFloat" required />
            </div>
        </div>

          
        <div class="form-group basic">
            <button type="submit" :disabled="sending" class="btn btn-primary btn-block btn-lg">Retirar</button>
        </div>
    </form>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {ethers} from 'ethers'
export default {
  name: 'HomeView',
  data() {
    return {
      // networks: [],
      sending: false,
      assetSelected: 0,
      networkSelected: 0,
      form: {
        to: '',
        amountFloat: '',
      }
    };
  },
  matches: {
    'assetSelected'() {
      this.networkSelected = 0;
    }
  },
  computed: {
    ...mapState(['portfolio']),
    networks() {
      return this.portfolio[this.assetSelected].networks_withdraw;
    },
    network() {
      return this.networks[this.networkSelected] ?? null;
    },
    asset() {
      return this.portfolio[this.assetSelected] ?? null;
    },
  },
  async mounted() {
    this.$root.loadBackButtom();
    this.$root.loadInputs();
  },
  methods: {
    /* eslint-disable */
    ...mapActions(['newNotification']),
    async formSubmit() {
      const self = this
      this.sending = true;
      await new Promise(r => setTimeout(r, 500));
      console.log('formSubmit', this.form)
      console.log('amountOut', this.form.amountFloat)
      console.log('asset', this.asset)

      try {
        const checkSum = ethers.getAddress(this.form.to);
        console.log('checkSum', checkSum)
        if (parseFloat(this.form.amountFloat) > parseFloat(this.network.src.balance)) {
          self.$swal.fire({
            title: "Fondos insuficientes",
            text: "No tienes fondos para esta transaccion.",
            icon: "error",
            draggable: false,
          }).then((result) => {
            this.sending = false;
            // if (result.isConfirmed) {}
          });
          return false;
        }
      } catch (error) {
          self.$swal.fire({
            title: "Cuenta de destino invalida",
            text: "Revisa la direccion (revisa mayusculas).",
            icon: "error",
            draggable: false,
          }).then((result) => {
            this.sending = false;
            // if (result.isConfirmed) {}
          });
          return false;
      }

      self.$swal.fire({
        title: "Saldo encontrado!",
        text: "Tu saldo a retirar es " + this.form.amountFloat + " " + self.asset.symbol,
        icon: "success",
        draggable: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, continuar!",
        cancelButtonText: "Cancelar"
      }).then((result) => {
        if (result.isConfirmed) {
          const data = {
            asset_id: this.assetSelected,
            to: this.form.to,
            amount: this.form.amountFloat,
            network_id: this.networkSelected,
          }
          console.log('data', data)
          location.replace(`/verify/withdraw/${data.network_id}/${data.asset_id}/${data.amount}/${data.to}`)
        }
      });

      this.sending = false;
      return false;
    },
  },
}
</script>